/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SubscriptionsPromoCodesGet200ResponsePromoCodesInner model module.
 * @module model/SubscriptionsPromoCodesGet200ResponsePromoCodesInner
 * @version 1.0.0
 */
class SubscriptionsPromoCodesGet200ResponsePromoCodesInner {
    /**
     * Constructs a new <code>SubscriptionsPromoCodesGet200ResponsePromoCodesInner</code>.
     * @alias module:model/SubscriptionsPromoCodesGet200ResponsePromoCodesInner
     */
    constructor() { 
        
        SubscriptionsPromoCodesGet200ResponsePromoCodesInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubscriptionsPromoCodesGet200ResponsePromoCodesInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubscriptionsPromoCodesGet200ResponsePromoCodesInner} obj Optional instance to populate.
     * @return {module:model/SubscriptionsPromoCodesGet200ResponsePromoCodesInner} The populated <code>SubscriptionsPromoCodesGet200ResponsePromoCodesInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubscriptionsPromoCodesGet200ResponsePromoCodesInner();

            if (data.hasOwnProperty('discountId')) {
                obj['discountId'] = ApiClient.convertToType(data['discountId'], 'String');
            }
            if (data.hasOwnProperty('promotionCodeId')) {
                obj['promotionCodeId'] = ApiClient.convertToType(data['promotionCodeId'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('couponId')) {
                obj['couponId'] = ApiClient.convertToType(data['couponId'], 'String');
            }
            if (data.hasOwnProperty('couponName')) {
                obj['couponName'] = ApiClient.convertToType(data['couponName'], 'String');
            }
            if (data.hasOwnProperty('percentOff')) {
                obj['percentOff'] = ApiClient.convertToType(data['percentOff'], 'Number');
            }
            if (data.hasOwnProperty('amountOff')) {
                obj['amountOff'] = ApiClient.convertToType(data['amountOff'], 'Number');
            }
            if (data.hasOwnProperty('currency')) {
                obj['currency'] = ApiClient.convertToType(data['currency'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SubscriptionsPromoCodesGet200ResponsePromoCodesInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SubscriptionsPromoCodesGet200ResponsePromoCodesInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['discountId'] && !(typeof data['discountId'] === 'string' || data['discountId'] instanceof String)) {
            throw new Error("Expected the field `discountId` to be a primitive type in the JSON string but got " + data['discountId']);
        }
        // ensure the json data is a string
        if (data['promotionCodeId'] && !(typeof data['promotionCodeId'] === 'string' || data['promotionCodeId'] instanceof String)) {
            throw new Error("Expected the field `promotionCodeId` to be a primitive type in the JSON string but got " + data['promotionCodeId']);
        }
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['couponId'] && !(typeof data['couponId'] === 'string' || data['couponId'] instanceof String)) {
            throw new Error("Expected the field `couponId` to be a primitive type in the JSON string but got " + data['couponId']);
        }
        // ensure the json data is a string
        if (data['couponName'] && !(typeof data['couponName'] === 'string' || data['couponName'] instanceof String)) {
            throw new Error("Expected the field `couponName` to be a primitive type in the JSON string but got " + data['couponName']);
        }
        // ensure the json data is a string
        if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
            throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
        }

        return true;
    }


}



/**
 * @member {String} discountId
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['discountId'] = undefined;

/**
 * @member {String} promotionCodeId
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['promotionCodeId'] = undefined;

/**
 * @member {String} code
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['code'] = undefined;

/**
 * @member {String} couponId
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['couponId'] = undefined;

/**
 * @member {String} couponName
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['couponName'] = undefined;

/**
 * @member {Number} percentOff
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['percentOff'] = undefined;

/**
 * @member {Number} amountOff
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['amountOff'] = undefined;

/**
 * @member {String} currency
 */
SubscriptionsPromoCodesGet200ResponsePromoCodesInner.prototype['currency'] = undefined;






export default SubscriptionsPromoCodesGet200ResponsePromoCodesInner;

